import { useSearchParams } from "react-router-dom";
import { ZellePayPanel } from "@/components/zelle/ZellePay";

export default function PayZellePage() {
  const [q] = useSearchParams();
  return (
    <div className="min-h-screen bg-slate-50 pt-28 pb-16 px-4" data-testid="pay-zelle-page">
      <div className="max-w-xl mx-auto bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 shadow-sm">
        <p className="text-xs font-bold tracking-widest text-violet-600 uppercase">Quick & free</p>
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mt-1 mb-5">Pay by Zelle</h1>
        <ZellePayPanel amount={Number(q.get("amount")) || 0} memo={q.get("memo") || ""} />
      </div>
    </div>
  );
}
